import { FormikForm } from 'components/Shared/FormikForm'
import { Form } from 'formik'
import styles from './OrderRatingForm.module.css'
import { FormRow } from 'components/Shared/CrudComponents'
import { RatingFieldComponent } from './RatingFieldComponent'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ContainedButton } from 'components/Shared/ContainedButton'
import { FieldComponent } from 'components/Shared/FieldComponent'

export function OrderRatingForm ({ values, onSubmit, schema, fields, disabled }) {
  const { t } = useTranslation()

  return (
    <div className={styles.ratingForm}>
      <FormikForm
        initialValues={values}
        onSubmit={onSubmit}
        validationSchema={schema}
      >
        <Form className={'w-100'}>
          {fields.map((field) => (
            <FormRow key={field.name} className={styles.formRow}>
              <RatingFieldComponent name={`${field.name}.value`}
                                    label={t(field.label)}
                                    disabled={disabled}/>
              <FieldComponent fieldName={`${field.name}.comment`}
                              label={t('orderRatingView.comment')}
                              className={styles.ratingComment}
                              multiline
                              disabled={disabled}/>
            </FormRow>
          ))}
          <ContainedButton
            className={styles.button}
            label={t('orderRatingView.ratingButtonLabel')}
          />
        </Form>
      </FormikForm>
    </div>
  )
}
